export enum FilterTypesEnum {
  Search = 'Search',
  FromDate = 'FromDate',
  ToDate = 'ToDate',
  Environment = 'Environment',
  Platform = 'Platform',
  Severity = 'Severity',
  ViolationCategory = 'Category',
  BusinessCriticality = 'Business Criticality',
  SecurityRisk = 'Security Risk',
  Integration = 'Integration',
  Playbook = 'Playbook',
  ResourceCategory = 'Resource Category',
  ResourceType = 'Type',
  ObjectType = 'Object Type',
  DataType = 'Data Type',
  Action = 'Action',
  Exempted = 'Exempted',
  ViolationStatus = 'Violation Status',
  ViolationStatusReason = 'Violation Status Reason',
  ResourceStatus = 'Resource Status',
  Policy = 'Policy',
  LastModifiedSinceDate = 'Last Modified Since',
  CreationTimeSinceDate = 'Creation Time Since',
  IdentityIsExternal = 'Identity Is External',
  allBuilders = 'All Builders',
  ConnectionConnectorType = 'Connection Connector Type',
  ConnectionInUse = 'Connection In Use',
  AutomationUsesAiModel = 'Automation Uses AI Model',
  AutomationUsesWebhook = 'Automation uses a webhook',
  AutomationUsesHttpStepsWithoutAuthentication = 'Automation uses http step without authentication',
  AutomationIsBotTrigger = 'Automation is a bot trigger',
  Owasp = 'OWASP LCNC',
  OwaspLlm = 'OWASP LLM',
  OwaspAsi = 'OWASP Agentic AI',
  OwaspNhi = 'OWASP NHI',
  Attack = 'MITRE ATT&CK',
  RelatedResource = 'Related Resource',
  ConnectorCategory = 'Connector Category',
  PolicyType = 'Policy Type',
  ViolationRule = 'Violation Rule',
  CreatedBy = 'Created By',
  OwnedBy = 'Owned By',
  PlaybookStatus = 'Playbook Status',
  ViolationRuleStatus = 'Violation Rule Status',
  EventDrivenSupport = 'Lightning Support',
  ExecutionStatus = 'Execution Status',
  LastExecutionSince = 'Last Execution Since',
  LastExecutionUntil = 'Last Execution Until',
  Role = 'Role',
  EnvironmentType = 'EnvironmentType',
  BotType = 'BotType',
  Department = 'Department',
  Label = 'Label',
  RuleTag = 'Rule Tag',
  GenerativeAiOptions = 'Gen-AI',
  PublicAccess = 'Public Access',
  OrgWideAccess = 'Org Wide Access',
  StepType = 'Type',
  Actor = 'Actor',
  ThreadId = 'Thread Id',
  FindingSeverity = 'Finding Severity',
  GenAiMatrix = 'AI Agents Attack Matrix',
  ClientApplication = 'Client Application',
  ChatMode = 'Chat Mode (M365)',
  ToolOrigin = 'Tool Origin',
  AiService = 'AI Service',
  AIAgentName = 'Agent',
  IsMcpHost = 'Is MCP Host',
  ObjectIdentifier = 'Object Identifier',
  User = 'User',
  ActorType = 'Actor Type',
  HasWritePermission = 'Has Write Permission',
  IssueStatus = 'Issue Status',
  IssueLabels = 'Issue Labels',
  FirstSeenFromDate = 'First Seen From Date',
  FirstSeenToDate = 'First Seen To Date',
  LastSeenFromDate = 'Last Seen From Date',
  LastSeenToDate = 'Last Seen To Date',
  InLineIntegration = 'Integration',
  InLineAiService = 'AI Service',
  InLineEnvironment = 'In-Line Environment',
  InLineThreadId = 'In-Line Thread ID',
  InLineStepType = 'Type',
  InLineActor = 'Actor',
  InLineAgent = 'Agent',
  InLineClientApplication = 'Client Application',
  InLineSeverity = 'Finding Severity',
  SensitivityLabel = 'Sensitivity Label',
  DataItem = 'Data Item',
  IssueSource = 'Rule Based Analysis',
  IntegrationStatus = 'Integration Status',
  RefreshMethod = 'Refresh Method',
}
